export const ActionTypes = {
  FETCH_ERP_EQUIPMENT_MAPPING_OPERATION: 'services/erpEquipmentMappingOperation/fetch_erp_equipment_mapping_operation',
  SET_ERP_EQUIPMENT_MAPPING_OPERATION: 'services/erpEquipmentMappingOperation/set_erp_equipment_mapping_operation',
  SET_ERP_EQUIPMENT_MAPPING_OPERATION_LOADER_STATUS:
    'services/erpEquipmentMappingOperation/set_erp_equipment_mapping_operation_loader_status',
  ADD_UPDATE_ERP_EQUIPMENT_MAPPING_OPERATION:
    'services/erpEquipmentMappingOperation/add_update_erp_equipment_mapping_operation',
  DELETE_ERP_EQUIPMENT_MAPPING_OPERATION:
    'services/erpEquipmentMappingOperation/delete_erp_equipment_mapping_operation',
  FETCH_ERP_EXIST: 'services/erpEquipmentMappingOperation/fetch_erp_exist',
  SET_ERP_EXIST: 'services/erpEquipmentMappingOperation/set_erp_exist',
};

const fetchERPEquipmentMapppingOperations = ({ erpEquipmentMappingOperationsParams }) => ({
  erpEquipmentMappingOperationsParams,
  type: ActionTypes.FETCH_ERP_EQUIPMENT_MAPPING_OPERATION,
});

const setERPEquipmentMapppingOperations = ({ erpEquipmentMapppingOperationData }) => ({
  erpEquipmentMapppingOperationData,
  type: ActionTypes.SET_ERP_EQUIPMENT_MAPPING_OPERATION,
});

const setERPEquipmentMapppingOperationLoaderStatus = ({ erpEquipmentMappingOperationsLoaderStatus }) => ({
  erpEquipmentMappingOperationsLoaderStatus,
  type: ActionTypes.SET_ERP_EQUIPMENT_MAPPING_OPERATION_LOADER_STATUS,
});

const addUpdateERPEquipmentMapppingOperation = ({
  actionName,
  erpEquipmentMappingOperationObj,
  erpEquipmentMappingOperationsParams,
}) => ({
  actionName,
  erpEquipmentMappingOperationObj,
  erpEquipmentMappingOperationsParams,
  type: ActionTypes.ADD_UPDATE_ERP_EQUIPMENT_MAPPING_OPERATION,
});

const deleteERPEquipmentMapppingOperation = ({ erpEquipmentMappingId }) => ({
  erpEquipmentMappingId,
  type: ActionTypes.DELETE_ERP_EQUIPMENT_MAPPING_OPERATION,
});

const fetchErpExist = ({ erpParams, funcCallback }) => ({
  erpParams,
  funcCallback,
  type: ActionTypes.FETCH_ERP_EXIST,
});

const setErpExist = ({ erpIdSearchData }) => ({
  erpIdSearchData,
  type: ActionTypes.SET_ERP_EXIST,
});

export default {
  fetchERPEquipmentMapppingOperations,
  setERPEquipmentMapppingOperations,
  setERPEquipmentMapppingOperationLoaderStatus,
  addUpdateERPEquipmentMapppingOperation,
  deleteERPEquipmentMapppingOperation,
  fetchErpExist,
  setErpExist,
};
